import { useDropoffLocations } from "@redotech/redo-customer-portal-shared/hooks/useDropoffLocations/use-dropoff-locations";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { LoadingRedoAnimation } from "@redotech/redo-web/loading-redo-animation";
import { Text } from "@redotech/redo-web/text";
import { memo, useState } from "react";
import { InteractiveMap } from "../in-store-locations";

const DropoffLocationsModal = memo(function DropoffLocationsModal({
  draftReturnId,
  returnId,
  customerCountry,
}: {
  draftReturnId?: string;
  returnId?: string;
  customerCountry?: string;
}) {
  const { t } = useTranslation();
  const { data, isPending, isError } = useDropoffLocations({
    draftReturnId,
    returnId,
  });

  if (isPending) {
    return <LoadingRedoAnimation />;
  }

  if (isError) {
    return (
      <Text textColor="error">{t("Error loading drop-off locations")}</Text>
    );
  }

  if (!data) {
    return null;
  }

  return <InteractiveMap customerCountry={customerCountry} locations={data} />;
});

export const DropoffLocationsButton = memo(function DropoffLocationsButton({
  draftReturnId,
  returnId,
  customerCountry,
  autoOpen = false,
}: {
  draftReturnId?: string;
  returnId?: string;
  customerCountry?: string;
  autoOpen?: boolean;
}) {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(autoOpen);

  return (
    <Flex>
      <RedoButton
        hierarchy="secondary"
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(true);
        }}
        text={t("See all locations")}
      />
      <RedoModal
        isOpen={isOpen}
        onModalCloseRequested={() => setIsOpen(false)}
        title={t("Find drop-off locations")}
      >
        <DropoffLocationsModal
          customerCountry={customerCountry}
          draftReturnId={draftReturnId}
          returnId={returnId}
        />
      </RedoModal>
    </Flex>
  );
});
